import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["generateAdvancedSearchUrl"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { AsyncProduct } from './async-product';
import CheckProductPermissions from './check-product-permissions';
import { useDialogExpansionContext } from '../../dialog-expansion-context';
import { AsyncProvider } from './result-provider';
import { useGenerateAdvancedSearchUrl } from './generate-advanced-search-url';

/**
 * A product within the Search Dialog. Each product responds to one tab inside the dialog and its children
 * are conditionally rendered based off whether this product is active
 *
 * The product component does the following
 * Permissions checking, to see if this product can be shown to the user
 * Product registration with the product router
 * Makes a result provider context available to its children
 * Conditionally rendering children if the product is active in the dialog
 * Async loading the component children using React.suspense
 */

export var SearchDialogProduct = function SearchDialogProduct(_ref) {
  var genUrl = _ref.generateAdvancedSearchUrl,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useDialogExpansionCo = useDialogExpansionContext(),
    isExpanded = _useDialogExpansionCo.isExpanded;
  var generateAdvancedSearchUrl = useGenerateAdvancedSearchUrl(genUrl);
  var props = _objectSpread(_objectSpread({}, rest), {}, {
    generateAdvancedSearchUrl: generateAdvancedSearchUrl
  });
  return /*#__PURE__*/React.createElement(CheckProductPermissions, props, /*#__PURE__*/React.createElement(AsyncProduct, _extends({}, props, {
    fallback: !isExpanded ? function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null);
    } : undefined
  }), /*#__PURE__*/React.createElement(AsyncProvider, props)));
};